import { render } from "./modalAjustes.vue?vue&type=template&id=7d1ffa3f&scoped=true"
import script from "./modalAjustes.vue?vue&type=script&lang=js"
export * from "./modalAjustes.vue?vue&type=script&lang=js"

import "./modalAjustes.vue?vue&type=style&index=0&id=7d1ffa3f&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1ffa3f"]])

export default __exports__